import { mapActions, mapState } from "vuex";
import JSEncrypt from "jsencrypt";
import formCheck from "@/components/common/formCheck";

export default {
  mixins: [formCheck],
  data() {
    let validateLoginName = (rule, value, callback) => {
      let length = this.chkstrlen(value);
      if (length > 24 || length < 4) {
        callback(new Error("长度在 4 到 24 个字符"));
      }
      if (/\s/.test(value)) {
        callback(new Error("用户名不能包含空格字符"));
      } else {
        callback();
        // if (this.userInfo && value === this.userInfo.account) {
        //   return callback();
        // }
        // let url = "USER.POST_USER_LIST";
        // let params = {
        //   account: value,
        //   current: 1,
        //   size: 1,
        // };
        // this.fetchData({
        //   url,
        //   method: "post",
        //   params,
        //   headers: { "Content-Type": "application/json" }
        // })
        //   .then((res) => {
        //     if (res.total != 0) {
        //       callback(new Error("用户名重复，请重新填写！"));
        //     } else {
        //       callback();
        //     }
        //   })
        //   .catch(() => {
        //     callback(new Error("用户名重复，请重新填写！"));
        //   });
      }
    };
    let validatePass = (rule, value, callback) => {
      if (/\s/.test(value)) {
        callback(new Error("密码不能包含空格字符"));
      } else {
        if (this.showType !== "newUser" && value === "") {
          callback();
        } else if (value === "") {
          callback(new Error("密码不能为空"));
        } else {
          if (this.form.confirmPassword !== "") {
            this.$refs.userDetailForm.validateField("confirmPassword");
          }
          callback();
        }
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (/\s/.test(value)) {
        callback(new Error("密码不能包含空格字符"));
      } else {
        if (this.showType !== "newUser" && value === "") {
          return callback();
        }
        if (value === "") {
          callback(new Error("确认密码不能为空"));
        } else if (value !== this.form.plainPassword) {
          callback(new Error("两次密码不一致!"));
        } else {
          callback();
        }
      }
    };
    let locationValidator = (rule, value, callback) => {
      if (this.isNationwide) {
        return callback()
      }
      if (!value || value.length === 0) {
        return callback(new Error("请选择区域"))
      }
      callback()
    }
    return {
      isNationwide: false, // 是否全国
      form: {
        id: "",
        account: "",
        phoneNum: "",
        userType: "",
        roleId: "",
        plainPassword: "",
        confirmPassword: "",
        realName: "",
        status: 1,
        location: [],
      },
      rules: {
        account: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            validator: validateLoginName,
            trigger: "blur",
          },
        ],
        plainPassword: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur",
          },
        ],
        phoneNum: [
          {
            required: true,
            validator: this.checkTel,
            trigger: "blur,change",
          },
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        roleId: [
          {
            required: true,
            message: "请选择角色",
            trigger: "change",
          },
        ],
        location: [
          {
            required: true,
            validator: locationValidator,
            trigger: "change",
          },
        ],
        userType: [
          {
            required: true,
            message: "请选择用户类型",
            trigger: "change",
          },
        ],
      },
      roles: [],
      submitLoading: false,
    };
  },
  created() {
    if (this.userInfo.id > 0) {
      this.coverForm()
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.common.user,
    }),
    // 是否只显示详情
    isShow() {
      return this.showType === 'showUser'
    },
    // 是否可选【全国】
    canCheckNationwide() {
      if (!this.isAdmin) return false
      if (this.form.userType != 2 && this.form.userType != 3) {
        return false
      }
      return true
    },
    // 是否拥有区域选择
    showNationSel() {
      if (this.form.userType == 4 || this.form.userType == 5) {
        return false
      }
      return true
    },
    // 区域限制
    areaLimit() {
      let userInfo = JSON.parse(window.localStorage.getItem('user'))
      if (userInfo.areaNationwide) {
        return []
      }
      let arr = []
      userInfo.provinceCode && arr.push({ level: 0, value: userInfo.provinceCode })
      userInfo.cityCode && arr.push({ level: 1, value: userInfo.cityCode })
      userInfo.regionCode && arr.push({ level: 2, value: userInfo.regionCode })

      return arr
    },
    isAdmin() {
      return this.currentUser.userType == 1;
    },
    isManager() {
      return this.currentUser.userType == 4;
    },
  },
  watch: {
    addModal(val) {
      if (val) {
        if (this.userInfo.id > 0) {
          this.coverForm()
        } else {
          this.resetForm();
        }
      }
    },
  },
  methods: {
    ...mapActions(["alertToggle", "fetchData"]),
    submitForm() {
      for (let key in this.form) {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      }
      this.$refs.userDetailForm.validate((valid, object) => {
        if (valid) {
          let location = [...this.form.location]
          let params = {
            ...this.form,
            areaNationwide: 0,
            password: this.getEncrypt(this.form.plainPassword),
            area: location.pop()
          }
          if (!this.form.plainPassword) {
            delete params.password
          }
          delete params.location
          delete params.plainPassword
          delete params.confirmPassword
          if (!params.id) delete params.id
          // 是否全国
          if (this.isNationwide) {
            params.areaNationwide = 1
            delete params.area
          }

          let url = "USER.POST_SAVE_OR_UPDATE";
          this.submitLoading = true;
          this.fetchData({ url, method: "post", params, isLoading: true, headers: { "Content-Type": "application/json" } })
            .then((res) => {
              if (res.success) {
                this.submitSuccess(this.showType, res);
              } else {
                this.$message.error(res.info || "操作失败！")
              }
            })
            .catch((err) => {
              this.$message.error(err || "新建用户失败")
            }).finally(() => {
              this.submitLoading = false;
            });
        } else {
          this.$message.error("信息填写有误，请检查后重新提交")
        }
      });
    },
    // 加密
    getEncrypt(data) {
      let publickKey =
        "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMKvDoYmZuEUIX5iG6b2b1GuJUYaqAMGm+NGGlTO59KP9ccqbW6KOSu0Cp3sewbXQnzIg5QxlKzySPH9p/SlnQIAT3eMhPRAj4iP6QZ8ZH6WzVquNTNZSHomQ03Pt/Ffx1AogBQVMgdMHFTN18L6kud3NSXGqqGx1ds+q5rrVYSwIDAQAB";
      let crypt = new JSEncrypt();
      crypt.setPublicKey(publickKey);
      let ret = crypt.encrypt(data);
      return ret;
    },
    resetForm() {
      if (this.userInfo.id === "" || this.userInfo.id == null) {
        this.form.account = "";
        this.form.phoneNum = "";
        this.form.userType = "";
        this.form.roleId = "";
        this.form.plainPassword = "";
        this.form.confirmPassword = "";
        this.form.realName = "";
        this.form.status = 1;
        this.form.location = [];
      } else {
        this.coverForm();
      }

      this.$nextTick(() => {
        this.$refs.userDetailForm.clearValidate();
      });
    },
    submitSuccess(type, res) {
      if (type === "newUser") {
        this.$message.success("新建用户成功！")
      } else {
        this.$message.success("编辑用户成功！")
      }
      this.$emit("success");
    },
    // 构建用户表单
    coverForm() {
      let userInfo = this.userInfo

      this.form = {
        id: userInfo.id,
        account: userInfo.account,
        phoneNum: userInfo.phoneNum,
        userType: userInfo.userType,
        roleId: userInfo.roleId,
        plainPassword: "",
        confirmPassword: "",
        realName: userInfo.realName,
        status: userInfo.status,
        areaNationwide: userInfo.areaNationwide,
        location: [],
      }
      this.isNationwide = userInfo.areaNationwide == 1
      
      userInfo.provinceCode && this.form.location.push(userInfo.provinceCode)
      userInfo.cityCode && this.form.location.push(userInfo.cityCode)
      userInfo.regionCode && this.form.location.push(userInfo.regionCode)
      userInfo.streetOfficeCode && this.form.location.push(userInfo.streetOfficeCode)
      userInfo.neighborCmmCode && this.form.location.push(userInfo.neighborCmmCode)

      this.$nextTick(() => {
        this.$refs.userDetailForm.clearValidate();
      });
    },
    // 获取字符串真实长度
    chkstrlen(str) {
      let strlen = 0;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 255)
          //如果是汉字，则字符串长度加2
          strlen += 2;
        else strlen++;
      }
      return strlen;
    },
  },
};
